module.exports = __webpack_public_path__ + "static/media/Novosti1.c69a29d6.png";